import { MaskitoOptions } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { maskitoPhoneOptionsGenerator } from '@maskito/phone';
import metadata from 'libphonenumber-js/min/metadata';

export let MaskFunctionOptions = [
  {
    label: 'ABA Routing',
    value: 'aba'
  },
  {
    label: 'Currency',
    value: 'currency'
  },
  {
    label: 'EIN',
    value: 'ein'
  },
  {
    label: 'GIIN',
    value: 'giin'
  },
  {
    label: 'ITIN',
    value: 'itin'
  },
  {
    label: 'Percent',
    value: 'percent'
  },
  {
    label: 'US Phone Number',
    value: 'phone'
  },
  {
    label: 'SSN',
    value: 'ssn'
  }
];

export let currencyMask = maskitoNumberOptionsGenerator({
  min: 0,
  precision: 2,
  prefix: '$',
  thousandSeparator: ','
});

export let currencyMaskExtended = maskitoNumberOptionsGenerator({
  min: 0,
  precision: 8,
  prefix: '$',
  thousandSeparator: ','
});

export let negativeCurrencyMask = maskitoNumberOptionsGenerator({
  precision: 2,
  prefix: '$',
  thousandSeparator: ','
});

export let positiveIntegerMask = maskitoNumberOptionsGenerator({
  min: 0,
  precision: 0,
  thousandSeparator: ''
});

export let decimalShortWithThousands = maskitoNumberOptionsGenerator({
  min: 0,
  precision: 2,
  thousandSeparator: ','
});

export const percentMask = maskitoNumberOptionsGenerator({
  min: 0,
  postfix: '%',
  thousandSeparator: ''
});

export let vehiclePercentMask = maskitoNumberOptionsGenerator({
  min: 0,
  postfix: '%',
  precision: 4,
  thousandSeparator: ''
});

export let phoneMask = maskitoPhoneOptionsGenerator({ countryIsoCode: 'US', metadata });

export let abaMask: MaskitoOptions = {
  mask: /^\d{0,9}$/
};

export let einMask: MaskitoOptions = {
  mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};

// This should produce this format
// XXXXXX.XXXXX.XX.XXX
export let giinMask: MaskitoOptions = {
  mask: [
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    '.',
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    '.',
    /[a-zA-Z]/,
    /[a-zA-Z]/,
    '.',
    /\d/,
    /\d/,
    /\d/
  ]
};

export let itinMask: MaskitoOptions = {
  mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
};

export let ssnMask: MaskitoOptions = {
  mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
};
